import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Downloads from './components/Downloads';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import { LanguageProvider } from './i18n/LanguageContext';

// 导入新创建的子页面组件
import TermsPage from './components/TermsPage';
import PrivacyPage from './components/PrivacyPage';
import FeaturesPage from './components/FeaturesPage';
import ChangelogPage from './components/ChangelogPage';
import HelpPage from './components/HelpPage';
import SubscriptionPage from './components/SubscriptionPage';

const scrollToSection = (hash) => {
  if (!hash) {
    return;
  }

  const element = document.getElementById(hash.replace(/^#/, ''));
  if (!element) {
    return;
  }

  const headerOffset = 96;
  const top = element.getBoundingClientRect().top + window.scrollY - headerOffset;
  window.scrollTo({ top, behavior: 'smooth' });
};

const HomePage = () => (
  <>
    <Hero />
    <Features />
    <Downloads />
    <FAQ />
  </>
);

const ScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const timer = window.setTimeout(() => scrollToSection(location.hash), 50);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const handleHashChange = () => {
      const timer = window.setTimeout(() => scrollToSection(window.location.hash), 50);
      return () => window.clearTimeout(timer);
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return null;
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToHash />
        <div className="font-sans antialiased text-gray-900 bg-white min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/features" element={<FeaturesPage />} />
              <Route path="/changelog" element={<ChangelogPage />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/subscription" element={<SubscriptionPage />} />

              {/* 兼容旧的 .html 路由 */}
              <Route path="/terms.html" element={<TermsPage />} />
              <Route path="/privacy.html" element={<PrivacyPage />} />
              <Route path="/features.html" element={<FeaturesPage />} />
              <Route path="/changelog.html" element={<ChangelogPage />} />
              <Route path="/help.html" element={<HelpPage />} />
              <Route path="/subscription.html" element={<SubscriptionPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
